import React from 'react';

const Breadcrumb = ({ category, title }) => {
  return (
    <span className='opacity-75' style={{ fontSize: '14px' }}>
      <a href='/' className='text-decoration-none text-black'>
        Home
      </a>{' '}
      &gt; <span className='text-capitalize'>{category}</span> {title && ` > ${title}`}
    </span>
  );
};

export default Breadcrumb;
